import React, { Component } from 'react';

class Day extends Component {
    _onDaySelect = () => {
        this.props.selectDay(this.props.fullDate);
    };
    render() {
        return (
            <li
                onClick={!(this.props.fullDate === this.props.selected) ? this._onDaySelect : null}
                className={`ckp-timetable-actions-option ${
                    this.props.fullDate === this.props.selected ? 'is-selected' : ''
                } ${this.props.small ? 'ckp-timetable-actions-option--small' : ''}`}
            >
                {this.props.small ? null : <span className="ckp-timetable-actions-label">{this.props.weekDay}</span>}
                <span className="ckp-timetable-actions-label is-small">{this.props.dayAndMonth}</span>
            </li>
        );
    }
}

export default Day;
